/**
 * Checks if 'value' is a truthy one.
 *
 * @param {*} value The value to check.
 * @returns {Boolean} True if the 'value' is truthy, else false.
 * @example
 *
 * isTruthy(true);
 * // -> true
 *
 * isTruthy(' ');
 * // -> true
 *
 * isTruthy(1);
 * // -> true
 *
 * isTruthy(false);
 * // -> false
 *
 * isTruthy('');
 * // -> false
 *
 * isTruthy();
 * // -> false
 *
 * isTruthy(0);
 * // -> false
 *
 * isTruthy(NaN);
 * // -> false
 */
export const isTruthy = (value) => {
  return value != null // value is existy
    && value !== false // obviously :)
    /* eslint-disable no-self-compare */
    && value === value  // check if is not NaN (NaN is falsy)
    /* eslint-enable no-self-compare */
    && value !== ''    // empty string is falsy
    && value !== 0;    // 0 is the only falsy number
};
